export enum CleverPushEvent {
  INITIALIZED = 'initialized',
  SUBSCRIBED = 'subscribed',
  UNSUBSCRIBED = 'unsubscribed',
  BELL_READY = 'bellReady',
  OPT_IN_SHOWN = 'optInShown',
  OPT_IN_CLOSED = 'optInClosed',
  PANEL_SHOWN = 'panelShown',
  TOPICS_SET = 'topicsSet',
}
